if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        // Unlock body scroll
        const scrollY = document.body.getAttribute('data-scroll-lock');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        document.body.removeAttribute('data-scroll-lock');
        
        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY));
        }

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            // Lock body scroll before showing modal
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            document.body.setAttribute('data-scroll-lock', scrollY);

            super.show(opener);
            
            setTimeout(() => {
              // Reinitialize slider components in the modal
              const sliderComponents = this.modalContent.querySelectorAll('slider-component');
              sliderComponents.forEach((slider) => {
                if (slider.initPages) {
                  slider.initPages();
                }
              });
              
              // Add drag-to-scroll functionality for thumbnail slider
              const thumbnailSlider = this.modalContent.querySelector('.thumbnail-list');
              if (thumbnailSlider) {
                let isDown = false;
                let startX;
                let scrollLeft;

                thumbnailSlider.addEventListener('mousedown', (e) => {
                  isDown = true;
                  thumbnailSlider.classList.add('active');
                  startX = e.pageX - thumbnailSlider.offsetLeft;
                  scrollLeft = thumbnailSlider.scrollLeft;
                  e.preventDefault();
                });

                thumbnailSlider.addEventListener('mouseleave', () => {
                  isDown = false;
                  thumbnailSlider.classList.remove('active');
                });

                thumbnailSlider.addEventListener('mouseup', () => {
                  isDown = false;
                  thumbnailSlider.classList.remove('active');
                });

                thumbnailSlider.addEventListener('mousemove', (e) => {
                  if (!isDown) return;
                  e.preventDefault();
                  const x = e.pageX - thumbnailSlider.offsetLeft;
                  const walk = (x - startX) * 2; // Scroll speed multiplier
                  thumbnailSlider.scrollLeft = scrollLeft - walk;
                });

                // Touch events for mobile
                let touchStartX = 0;
                let touchScrollLeft = 0;

                thumbnailSlider.addEventListener('touchstart', (e) => {
                  touchStartX = e.touches[0].pageX - thumbnailSlider.offsetLeft;
                  touchScrollLeft = thumbnailSlider.scrollLeft;
                }, { passive: true });

                thumbnailSlider.addEventListener('touchmove', (e) => {
                  const x = e.touches[0].pageX - thumbnailSlider.offsetLeft;
                  const walk = (x - touchStartX) * 2;
                  thumbnailSlider.scrollLeft = touchScrollLeft - walk;
                }, { passive: true });
              }
              
              if (window.initAllIngredientSwipers) {
                window.initAllIngredientSwipers();
              }
              
              // Function to update variant ID input
              const updateVariantIdInput = (variantId) => {
                const variantIdInput = this.modalContent.querySelector('.product-variant-id');
                if (variantIdInput && variantId) {
                  variantIdInput.value = variantId;
                }
              };
              
              const firmhouseContainers = this.modalContent.querySelectorAll('.firmhouse_selling_plan_app_container');
              if (firmhouseContainers.length > 0) {
                // Get initial variant ID
                const masterSelect = this.modalContent.querySelector('[data-product-master-select], input[name="id"]');
                const initialVariantId = masterSelect?.value;
                
                // Loop through each firmhouse container
                firmhouseContainers.forEach((firmhouseContainer) => {
                  // Set initial active state
                  if (initialVariantId) {
                    const options = firmhouseContainer.querySelectorAll('.custom-select__option');
                    
                    if (options.length) {
                      options.forEach(option => option.classList.remove('active'));
                      const activeOption = firmhouseContainer.querySelector(`.custom-select__option[data-value="${initialVariantId}"]`);
                      
                      if (activeOption) {
                        activeOption.classList.add('active');
                        updateVariantIdInput(initialVariantId);
                        
                        // Find and check the corresponding radio button
                        const radioArea = activeOption.closest('.sales_option_widget__one_time_purchase_option, .sales_option_widget__subscription_option');
                        if (radioArea) {
                          const radioButton = radioArea.querySelector('.sales_option_widget__radio-area__radio input[type="radio"]');
                          if (radioButton && !radioButton.checked) {
                            radioButton.checked = true;
                          }
                        }
                      }
                    }
                  }
                  
                  // Add click event listener for custom select options
                  firmhouseContainer.addEventListener('click', (event) => {
                    const clickedOption = event.target.closest('.custom-select__option');
                    if (clickedOption && clickedOption.dataset.value) {
                      // Remove active class from all options in ALL containers
                      firmhouseContainers.forEach((container) => {
                        container.querySelectorAll('.custom-select__option').forEach(opt => {
                          opt.classList.remove('active');
                        });
                      });
                      
                      // Add active class to clicked option
                      clickedOption.classList.add('active');
                      
                      // Update the hidden input with the selected variant ID
                      updateVariantIdInput(clickedOption.dataset.value);
                      
                      // Find and check the corresponding radio button
                      const radioArea = clickedOption.closest('.sales_option_widget__one_time_purchase_option, .sales_option_widget__subscription_option');
                      if (radioArea) {
                        const radioButton = radioArea.querySelector('.sales_option_widget__radio-area__radio input[type="radio"]');
                        if (radioButton && !radioButton.checked) {
                          radioButton.checked = true;
                        }
                      }
                    }
                  });
                });
              }
            }, 100);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden'); 
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
